module.exports = __webpack_public_path__ + "img/twitter.50442fbf.svg";